import { sistemaGeneral } from "./Sistema";
import dayjs from "dayjs";

export default function CardCliente({
    contrato
}) {
    const { logo, nombre } = sistemaGeneral(contrato.paquete.sistema);

    return (
        <>
            <div className="d-flex flex-wrap flex-sm-nowrap pt-9" tabIndex={-1}>
                <div className="d-flex flex-center flex-shrink-0 bg-light rounded w-100px h-100px w-lg-150px h-lg-125px me-7 mb-4">
                    <img className="mw-60px mw-lg-85px" src={logo} alt={nombre}/>
                </div>
                <div className="flex-grow-1">
                    <div
                        className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                        <div className="d-flex flex-column">
                            <div className="d-flex align-items-center">
                                <span className="fs-2 fw-bold me-3">
                                  { contrato.cliente.cliente }
                                </span>
                            </div>
                            <div className="d-flex flex-wrap fs-5 text-gray-500 align-items-end">
                                <i className="ki-solid ki-profile-user fs-2 text-center me-2"></i>
                                {
                                    contrato.usuarios && contrato.usuarios.map((usuario, index) => {
                                        return index + 1 === contrato.usuarios.length ? `${usuario.usuario} ` : `${usuario.usuario}, `
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="d-flex flex-wrap">
                            <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-3 mb-3">
                                <div className="fw-semibold fs-6 text-gray-500">
                                    Paquete:
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="fs-4 text-uppercase">
                                        { contrato.paquete.paquete }
                                    </div>
                                </div>
                            </div>
                            <div
                                className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-3 mb-3">
                                <div className="fw-semibold fs-6 text-gray-500">
                                    Corte:
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="fs-4 text-uppercase">
                                        Dias {contrato.corte}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-3 mb-3">
                                <div className="fw-semibold fs-6 text-gray-500">
                                    &Uacute;ltimo Pago:
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="fs-4 text-uppercase">
                                        {
                                            (contrato.ultimo_pago && contrato.ultimo_pago.fecha_pago) ? ( dayjs(contrato.ultimo_pago.fecha_pago).format('MMM. DD, YYYY') ) : ("Sin fecha")
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={"border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-3 mb-3 " + (dayjs().isAfter(dayjs(contrato.hasta), 'date') ? "bg-light-danger" : "bg-light-success")}>
                                <div className="fw-semibold fs-6 text-gray-500">
                                    Vigente hasta:
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="fs-4 text-uppercase">
                                        {dayjs(contrato.hasta).format('MMM. DD, YYYY')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
